import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import '../../atoms/buttons/enums.js';
import '../../utilities/dom-helpers/index.js';
import { lineClamp } from '../../utilities/text-helpers/index.js';
import { imgLazyLoadingResolver } from '../../../common/img-lazy-loading-resolver.js';
import css_248z from './social-proof-item.scss.js';

class SocialProofItem extends s {
    firstUpdated() {
        const paragraphSlot = this.shadowRoot.querySelector('slot[name="paragraph"]');
        const text = paragraphSlot.assignedNodes()[0];
        text.textContent = lineClamp(text.textContent, 180);
        imgLazyLoadingResolver(this.renderRoot);
    }
    render() {
        return x `<div class="social-proof-item"><slot name="media-block"></slot><slot name="name"></slot><slot name="position"></slot><slot name="paragraph"></slot><slot name="primary-cta"></slot></div>`;
    }
}
SocialProofItem.styles = css_248z;
customElements.define('social-proof-item', SocialProofItem);

export { SocialProofItem };
